import { CSSProperties, ReactElement } from 'react';
import { classNames } from '~/v2/utils/general';

type Props = {
  title: ReactElement;
  hideDecoration?: boolean | undefined;
  className?: string | undefined;
  style?: CSSProperties | undefined;
};
function SectionTitle({ title, hideDecoration = false, className, style }: Props) {
  return (
    <div className={`section-title ${classNames(className)}`} style={style}>
      <h2>{title}</h2>
      {!hideDecoration && <div className='section-title-decoration' />}
    </div>
  );
}

export default SectionTitle;
